/**
 * Citi Pay OSM Scripts
 *
 * NOTE: This file relies on Shopify's JIT compilation
 *       which means you should write in style using ES5 or lower.
 *
 *       Check this file's payload in the browser network tab
 *       to ensure JIT is working as expected
 *       (i.e., you should see no errors).
 *
 *       See: https://shopify.dev/docs/themes/best-practices/file-transformation#just-in-time-file-transformations
 */
((window, document) => {
  console.debug("CPOSM: Debug: Scripts loaded!");

  var CPOSM = {
    events: {
      loaded: "cposm:loaded",
      ready: "cposm:ready",
    },

    settings: {
      autoInit: true,
      previewCartSelector: "[data-js-cp-osm-preview-cart]",
      learnMoreTemplateSelector: "[data-js-cp-osm-learn-more]",
      learnMoreThreshold: 30000,
      learnMoreAmount: 0,
    },

    _learnMoreTemplate: undefined,
    _getLearnMoreTemplate: function() {
      if (!this._learnMoreTemplate) {
        this._learnMoreTemplate = document.querySelector(
          this.settings.learnMoreTemplateSelector,
        );
      }
      return this._learnMoreTemplate;
    },

    _getPreviewCartPlacements: function() {
      // NOTE: We're not caching this since the dom can be changed / re-rendered.
      return document.querySelectorAll(this.settings.previewCartSelector);
    },

    init: function() {
      console.debug("CPOSM: Debug: Init ran!");

      var threshold = this.settings.learnMoreThreshold;
      var amount = this.settings.learnMoreAmount;

      this.tryRenderPreviewCartLearnMore({
        threshold: threshold,
        amount: amount,
      });
    },

    tryRenderPreviewCartLearnMore: function(options) {
      console.debug(
        "CPOSM: Debug: tryRenderPreviewCartLearnMore ran!",
        options,
      );

      if (this._getPreviewCartPlacements().length == 0) {
        console.warn(
          `CPOSM: Warning: Could not find preview cart placements! Aborting...`,
        );
        return;
      }

      if (!this._getLearnMoreTemplate()) {
        console.warn(
          `CPOSM: Warning: Could not find learn more template! Aborting...`,
        );
        return;
      }

      var threshold = options.threshold;
      var amount = options.amount;

      if (amount >= threshold) {
        console.debug("CPSOM: Debug: Rendering preview cart placements...");
        this.renderPreviewCartLearnMore();
      } else {
        console.debug("CPSOM: Debug: Removing preview cart placements...");
        this.removePreviewCartLearnMore();
      }
    },

    renderPreviewCartLearnMore: function() {
      var template = this._getLearnMoreTemplate();
      var placements = this._getPreviewCartPlacements();
      for (i = 0; i < placements.length; i++) {
        var el = placements[i];
        var deepClone = true;

        el.innerHTML = "";
        el.appendChild(template.content.cloneNode(deepClone));

        console.debug("CPSOM: Debug: Rendered preview cart placement", el);
      }
    },

    removePreviewCartLearnMore: function() {
      var placements = this._getPreviewCartPlacements();
      for (i = 0; i < placements.length; i++) {
        var el = placements[i];
        el.remove();
      }
    },

    // Private Methods

    _dispatch: (event) => {
      console.debug(`CPOSM: Debug: Dispatching event: ${event}...`);
      window.dispatchEvent(new CustomEvent(event, { detail: { CPOSM: this } }));
    },
  };

  // Settings & Namespace Setup

  window.CPOSM_SETTINGS = window.CPOSM_SETTINGS || {};
  CPOSM.settings = Object.assign(CPOSM.settings, CPOSM_SETTINGS);
  window.CPOSM = window.CPOSM || CPOSM;

  // Events – Loaded

  CPOSM._dispatch(CPOSM.events.loaded);

  // Events – Ready

  window.addEventListener("DOMContentLoaded", () => {
    CPOSM._dispatch(CPOSM.events.ready);
    if (CPOSM.settings.autoInit) CPOSM.init();
  });
})(window, document);
